import { Panel } from "primereact/panel";
import { useForm } from "react-hook-form";
import { InfoCpn } from "../../../models/cpn/InfoCpn";
import { InputComponent } from "../../../components/InputComponent";
import { useEffect, useState } from "react";
import { CatalogoService } from "../../../service/CatalogoService";
import * as generic from '../../../components/Generico';
import { ClientePNService } from "../../../service/ClientePNService";
import { BottomActionBar } from "../../../components/ui/BottomActionBar";
import { ProgressSpinner } from "primereact/progressspinner";

export const DatosPn = ({ id, siCliente, catalogos, toast, seccion, nuevoCliente, next, permss, soloLectura }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new InfoCpn({ proyecto: catalogos?.tcompania?.etiqueta });
    const defaultValues = generic.funDefault(omodel.model);
    const catalogoSrv = new CatalogoService();
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue, clearErrors } = useForm({ defaultValues, mode: 'onTouched' });
    const { inDrop, inText, inCalendar, inDropMultiple } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [siCompania, setSiCompania] = useState(true);
    const [esCedula, setEsCedula] = useState(false);
    const clientepnSrv = new ClientePNService();
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onChangePais = (e) => {
        setEcuador(e.value?.cat_id === catalogos.ecuador?.cat_id);
        setValue('provincia', null);
        setValue('ciudad', null);
        setCiudades([]);
    }

    const onChangeProvincia = (e) => {
        setValue('ciudad', null);
        if (!e?.value) {
            setCiudades([]);
            return;
        }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudades(res.data);
        });
    }

    const onChangeTipoIdentificacion = (e) => {
        setEsCedula(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion');
    }

    const editFicha = () => {
        setIsLoading(true);
        clientepnSrv.consultarClientepn(id ?? 0, seccion).then(res => {
            const cats = catalogos;
            const _clientepn = res.data.clientepn;
            if (!_clientepn) {
                reset(defaultValues);
                return;
            }
            if (res.data.ciudades) {
                setCiudades(res.data.ciudades);
            }
            if (cats?.grupo?.length > 0) {
                setSiCompania(false);
                if (_clientepn.grupo) {
                    _clientepn.grupo = cats.grupo.filter(item => _clientepn.grupo.includes(item.cat_id));
                } else {
                    _clientepn.grupo = null;
                }
            }
            setEcuador(_clientepn.pais?.cat_id === cats.ecuador?.cat_id);
            setEsCedula(_clientepn.tipo_identificacion?.cat_id === cats?.cedula?.cat_id);
            _clientepn.fecha = generic.stringToDate(_clientepn.fecha);
            _clientepn.fecha_nacimiento = generic.stringToDate(_clientepn.fecha_nacimiento);
            reset(generic.renewValues(_clientepn, omodel.model));
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onSubmit = (data) => {
        data.seccion = seccion;
        data.fecha = data.fecha.toISOString().split('T')[0];
        data.fecha_nacimiento = data.fecha_nacimiento.toISOString().split('T')[0];
        data.ec = catalogos.ecuador.cat_id;
        data.grp = catalogos?.grupo?.length ?? 0;
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa ?? null;
        setIsSaving(true);
        const accion = id == null ? clientepnSrv.newClientepn(data) : clientepnSrv.editarClientepn({ ...data, id });
        accion.then(res => {
            nuevoCliente(res.data); // Si es nuevo, actualiza el id, nemonico y civil, caso contrario solo civil
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setIsSaving(false);
        });
    }

    const tipoDoc = esCedula ? 'IDEN_CEDULA' : null;

    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || `Cédula incorrecta`;
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('A', 'DATOS DE LA SOLICITUD', 'pi pi-cog')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {catalogos?.grupo?.length > 0 &&
                        inDropMultiple('grupo', catalogos?.grupo, { lab: omodel.optionLabel }, (!siCliente && catalogos?.empresas && !id) ? 6 : 12)
                    }
                    {!siCliente && catalogos?.empresas && !id &&
                        inDrop('empresa', catalogos?.empresas, { lab: omodel.optionLabel }, (catalogos?.grupo?.length > 0) ? 6 : 12)
                    }
                    {inCalendar('fecha', {}, 3)}
                    {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, 3)}
                    {ecuador ? (
                        <>
                            {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 3)}
                            {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 3)}
                        </>
                    ) : (
                        inText('canton', { icon: 'pi pi-map-marker' }, 6)
                    )}
                    {siCompania && !esTipoEspecial && inText('compania', { icon: 'pi pi-building' }, 3)}
                    {!esTipoEspecial && inText('proyecto', { icon: 'pi pi-briefcase' }, siCompania ? 3 : 6)}
                    {inDrop('tipo_formulario', catalogos?.tipoFormulario, { lab: omodel.optionLabel }, esTipoEspecial ? 6 : 3)}
                    {inDrop('tipo_solicitante', catalogos?.tipoSolicitante, { lab: omodel.optionLabel }, esTipoEspecial ? 6 : 3)}
                </div>
            </Panel>
            <Panel header={generic.renderPanelHeader('A.1', 'DATOS PERSONALES', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inText('apellidos', { icon: 'pi pi-user-edit' }, 3)}
                    {inText('nombres', { icon: 'pi pi-user' }, 3)}
                    {inDrop('tipo_identificacion', catalogos?.tipo, { lab: omodel.optionLabel, chn: onChangeTipoIdentificacion }, 3)}
                    {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 3)}
                    <div className="col-12 mt-2 mb-2">
                        <div className="border-top-1 border-300"></div>
                    </div>
                    {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: omodel.optionLabel }, 3)}
                    {inCalendar('fecha_nacimiento', {}, catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' ? 2 : 3)}
                    {inDrop('genero', catalogos?.genero, { lab: omodel.optionLabel }, catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' ? 2 : 3)}
                    {inDrop('estado_civil', catalogos?.estado_civil, { lab: omodel.optionLabel }, catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' ? 2 : 3)}
                    {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' &&
                        inDrop('separacion_bienes', generic.estadosSiNo, { lab: omodel.optionLabel }, 3)
                    }
                </div>
            </Panel>
            <BottomActionBar onNext={next} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    )
}
